import { render, staticRenderFns } from "./Immocode.vue?vue&type=template&id=28baad7e&"
import script from "./Immocode.vue?vue&type=script&lang=ts&"
export * from "./Immocode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports